import React from 'react';

import { Box } from '@nerdwallet/currency/components/Box';
import { Text } from '@nerdwallet/currency/components/Text';
import { colors } from '@nerdwallet/base-styles/variables';
import { colors as nwPlusColors } from '@nerdwallet/nerdwallet-plus-components';
import classes from '@nerdwallet/base-styles/classes';

import ProgressBar from '@components/progress-bar/progress-bar';
import { RewardPointsLabel } from '@components/nerdwallet-plus/reward-points-label';

import styles from '../rewards-tracker/rewards-tracker.module.scss';
import { RewardableEventType } from '@generated-gql/generated-types';

interface Props {
  eventType: RewardableEventType;
  points: number;
  amountOfSteps: number;
  amountOfCompletedSteps: number;
  headerText: string;
  displayCondition: boolean;
  showPointsForNonMembers?: boolean;
}

const RewardTrackerHeader: React.FC<Props> = ({
  eventType,
  points,
  amountOfSteps,
  amountOfCompletedSteps,
  headerText,
  showPointsForNonMembers,
}) => {
  return (
    <>
      <RewardPointsLabel
        eventType={eventType}
        points={points}
        showForNonMembers={showPointsForNonMembers}
        displayCondition={amountOfSteps !== amountOfCompletedSteps && !!points}
        atEdge
        className={classes('padding-top-3')}
      />
      <Box
        display="flex"
        flexDirection="row"
        paddingY="3"
        paddingX={{ mobile: '3', desktop: '4' }}
        gridGap={3}
        justifyContent="space-between"
        alignItems="flex-start"
        tabIndex={0}
      >
        <Text size="large" bold>
          {headerText}
        </Text>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        gridGap={2}
        paddingX={{ mobile: '3', desktop: '4' }}
        paddingBottom="2"
        tabIndex={0}
      >
        <Box className={styles.progressBar}>
          <ProgressBar
            rounded
            height={16}
            denominator={amountOfSteps}
            numerator={amountOfCompletedSteps}
            barColor={colors.green}
            backgroundColor={nwPlusColors['lime-tint-lp-2']}
          />
        </Box>
        <Box className={styles.completedStepsContainer}>
          <Text
            light
          >{`${amountOfCompletedSteps}/${amountOfSteps} tasks`}</Text>
        </Box>
      </Box>
    </>
  );
};

export default RewardTrackerHeader;
